import { SavedReportCompanyReport } from '../types-store';

export const normalizeSequence = (items?: SavedReportCompanyReport[]): SavedReportCompanyReport[] => {

  return [...(items || [])]
    .sort((item1, item2) => (item1.code?.description ?? '').localeCompare(item2.code?.description ?? ''))
    .map((item, index) => item.sequence === index + 1
      ? item
      : {
        ...item,
        sequence: index + 1
      }
    );
};
